import React from 'react';

// Shared card/form primitives for the dark-tactical app shell.
// Primary accent: --fff-volt (#BEFF38). Orange kept only for phase/intensity
// pills elsewhere (e.g. TargetsCard).
export const Card = ({ title, icon: Icon, action, children, className = '' }) => (
  <div className={`rounded-2xl border border-zinc-800 bg-zinc-950/60 backdrop-blur p-5 lg:p-6 ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between gap-3 mb-4 flex-wrap">
        <h3
          className="text-white font-black uppercase tracking-tight text-lg lg:text-xl flex items-center gap-2"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
        >
          {Icon && <Icon className="w-5 h-5 text-[#BEFF38]" strokeWidth={2.5} />} {title}
        </h3>
        {action}
      </div>
    )}
    {children}
  </div>
);

export const LabeledInput = ({ label, hint, ...props }) => (
  <label className="flex flex-col gap-1.5 text-sm">
    <span className="text-zinc-300 font-medium">{label}</span>
    <input
      {...props}
      className="bg-[#0b0c10] border border-zinc-800 focus:border-[#BEFF38] focus:ring-2 focus:ring-[#BEFF38]/20 rounded-lg px-3 py-2.5 text-white outline-none transition-colors"
    />
    {hint && <span className="text-[11px] text-zinc-500">{hint}</span>}
  </label>
);

export const LabeledSelect = ({ label, children, ...props }) => (
  <label className="flex flex-col gap-1.5 text-sm">
    <span className="text-zinc-300 font-medium">{label}</span>
    <select
      {...props}
      className="bg-[#0b0c10] border border-zinc-800 focus:border-[#BEFF38] focus:ring-2 focus:ring-[#BEFF38]/20 rounded-lg px-3 py-2.5 text-white outline-none transition-colors"
    >{children}</select>
  </label>
);

export const Chip = ({ active, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={`px-3 py-1.5 rounded-full text-sm font-semibold border transition-colors ${
      active
        ? 'bg-[#BEFF38] text-black border-[#BEFF38]'
        : 'bg-zinc-900/60 text-zinc-300 border-zinc-800 hover:border-zinc-600'
    }`}
  >
    {children}
  </button>
);

export const Btn = ({ children, variant = 'primary', className = '', ...rest }) => {
  const base = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full font-black text-xs uppercase tracking-widest transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  const styles = variant === 'primary'
    ? 'bg-[#BEFF38] text-black hover:bg-[#a8e62e] shadow-[0_4px_18px_-6px_rgba(190,255,56,0.35)]'
    : variant === 'ghost'
      ? 'border border-zinc-700 text-zinc-200 hover:border-[#BEFF38] hover:text-white'
      : 'bg-zinc-900 border border-zinc-800 text-[#BEFF38] hover:border-[#BEFF38]';
  return <button className={`${base} ${styles} ${className}`} {...rest}>{children}</button>;
};

export const Stat = ({ label, value, sub }) => (
  <div className="rounded-xl border border-zinc-800 bg-zinc-950/60 p-3">
    <p className="text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 font-bold">{label}</p>
    <p className="text-white font-black text-lg mt-1" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>{value}</p>
    {sub && <p className="text-[11px] text-zinc-500 mt-0.5">{sub}</p>}
  </div>
);

export const Empty = ({ children }) => (
  <p className="text-zinc-500 text-sm italic">{children}</p>
);
